import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=3c8bddee&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"
import style0 from "./Album.vue?vue&type=style&index=0&id=3c8bddee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8bddee",
  null
  
)

export default component.exports